/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroupTypeEnum,
    DisciplineGroupTypeEnumFromJSON,
    DisciplineGroupTypeEnumFromJSONTyped,
    DisciplineGroupTypeEnumToJSON,
} from './DisciplineGroupTypeEnum';
import {
    DisciplineSubgroup,
    DisciplineSubgroupFromJSON,
    DisciplineSubgroupFromJSONTyped,
    DisciplineSubgroupToJSON,
} from './DisciplineSubgroup';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyPlan,
    StudyPlanFromJSON,
    StudyPlanFromJSONTyped,
    StudyPlanToJSON,
} from './StudyPlan';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';

/**
 * 
 * @export
 * @interface DisciplineGroup
 */
export interface DisciplineGroup {
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroup
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof DisciplineGroup
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DisciplineGroup
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroup
     */
    name?: string | null;
    /**
     * 
     * @type {DisciplineGroupTypeEnum}
     * @memberof DisciplineGroup
     */
    type?: DisciplineGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DisciplineGroup
     */
    disciplineCount?: number;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof DisciplineGroup
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof DisciplineGroup
     */
    year?: StudyYearEnum;
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroup
     */
    studyPlanId?: string;
    /**
     * 
     * @type {StudyPlan}
     * @memberof DisciplineGroup
     */
    studyPlan?: StudyPlan;
    /**
     * 
     * @type {Array<DisciplineSubgroup>}
     * @memberof DisciplineGroup
     */
    subgroups?: Array<DisciplineSubgroup> | null;
}

export function DisciplineGroupFromJSON(json: any): DisciplineGroup {
    return DisciplineGroupFromJSONTyped(json, false);
}

export function DisciplineGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : DisciplineGroupTypeEnumFromJSON(json['type']),
        'disciplineCount': !exists(json, 'disciplineCount') ? undefined : json['disciplineCount'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'year': !exists(json, 'year') ? undefined : StudyYearEnumFromJSON(json['year']),
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'studyPlan': !exists(json, 'studyPlan') ? undefined : StudyPlanFromJSON(json['studyPlan']),
        'subgroups': !exists(json, 'subgroups') ? undefined : (json['subgroups'] === null ? null : (json['subgroups'] as Array<any>).map(DisciplineSubgroupFromJSON)),
    };
}

export function DisciplineGroupToJSON(value?: DisciplineGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'type': DisciplineGroupTypeEnumToJSON(value.type),
        'disciplineCount': value.disciplineCount,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'year': StudyYearEnumToJSON(value.year),
        'studyPlanId': value.studyPlanId,
        'studyPlan': StudyPlanToJSON(value.studyPlan),
        'subgroups': value.subgroups === undefined ? undefined : (value.subgroups === null ? null : (value.subgroups as Array<any>).map(DisciplineSubgroupToJSON)),
    };
}

